export const ePaperWidth = 3307;
export const ePaperHeight = 4677;